import { makeAutoObservable } from "mobx";

class Store {
  listOfWords = [];
  error = null;
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  setLoading = (value) => {
    this.loading = value;
  };
  setError = (value) => {
    this.error = value;
  };
  setListOfWords = (payload) => {
    this.listOfWords = payload;
  };
}
export default Store;
